/* eslint-disable import/first */
/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.sass';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

/* Material-UI Setup */
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

/* React Router Setup */
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

/* Redux Setup */
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import RootReducer from './reducers/RootReducer';

/* Redux Saga Setup */
import createSagaMiddleware from 'redux-saga';
import RootSaga from './sagas/RootSaga';

const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();
const store = createStore(RootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(RootSaga);

const MuiTheme = getMuiTheme({
  fontFamily: '"Quicksand", sans-serif'
});

ReactDOM.render(
  <MuiThemeProvider muiTheme={MuiTheme}>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js